import React, { useState } from 'react'
import { Button, TextField } from "@mui/material";
import { fetch } from '../../Common/API';
import { config } from '../../config';
import SafariTextField from '../../Common/SafariTheme'
import detectBrowser from '../../Common/FindBrowser'

export default function MockLogin() {
    const findBrowser = detectBrowser()

  const appURL = config.appURL;
  const spcpReturnUrl = config.spcpReturnUrl;
  const spcpForeignCroppassUEN = config.spcpForeignCroppassUEN;

  const [uen, setUen] = useState("");
  const [nric, setNRIC] = useState("");
  const [name, setName] = useState("");

  const spcpURL = `${appURL}/api/Auth/GetSPCPLoginURL?target=${spcpReturnUrl}&clientState=s=${nric},name=${name},u=${uen},uType=UEN&isCorppass=1`;

  const login = async () => {
            const companyName = uen + " Company";
            let url = spcpURL;
            const uenCountryPairs = spcpForeignCroppassUEN.split('|');
            const uenUpper = uen.trim().toUpperCase();
            const uenFound = uenCountryPairs.find(pair => pair.split(':')[0].trim().toUpperCase() === uenUpper);
            if (uenFound) {
                const country = uenFound.split(':')[1];
                url = `${appURL}/api/Auth/GetSPCPLoginURL?target=${spcpReturnUrl}&clientState=s=${nric},name=${name},u=${uenUpper},uType=NON-UEN,uCountry=${country},uName=${companyName}&isCorppass=1`;
            }
            const getSPCPLoginInfoResponse = await fetch(url, 'GET', null);
            window.location.href = getSPCPLoginInfoResponse.data.spcPloginURL;
        }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            {findBrowser !== 'Safari' ?
            <>
            <div style={{ marginTop: '16px' }}>
                <TextField
                    hiddenLabel
                    id="filled-hidden-label-small"
                    label="UEN"
                    variant="outlined"
                    size="small"
                    value={uen}
                    onChange={e => setUen(e.target.value)}
                />
            </div>
            <div style={{ marginTop: '16px' }}>
                <TextField
                    hiddenLabel
                    id="filled-hidden-label-small"
                    label="NRIC"
                    variant="outlined"
                    size="small"
                    value={nric}
                    onChange={e => setNRIC(e.target.value)}
                    margin="none"
                    sx={{ '& .MuiInputBase-root': { margin: 0, padding: 0}, '& .MuiFilledInput-root': {marginTop: 0}  }}
                />
            </div>
            <div style={{ marginTop: '16px' }}>
                <TextField
                    hiddenLabel
                    id="filled-hidden-label-small"
                    label="Name"
                    variant="outlined"
                    size="small"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    margin="none"
                    sx={{ '& .MuiInputBase-root': { margin: 0, padding: 0}, '& .MuiFilledInput-root': {marginTop: 0}  }}
                />
            </div>             
            </>
            :
            <>
            <div style={{ marginTop: '24px' }}>
                <SafariTextField
                    id="filled-hidden-label-normal"
                    label="UEN"
                    value={uen}
                    onChange={e => setUen(e.target.value)}
                    variant="filled"
                    style={{ marginTop: 11 }}
                />
            </div>
            <div style={{ marginTop: '24px' }}>
                <SafariTextField
                    id="filled-hidden-label-normal"
                    label="NRIC"
                    value={nric}
                    onChange={e => setNRIC(e.target.value)}
                    variant="filled"
                    style={{ marginTop: 11 }}
                />
            </div> 
            <div style={{ marginTop: '24px' }}>
                <SafariTextField
                    id="filled-hidden-label-normal"
                    label="Name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    variant="filled"
                    style={{ marginTop: 11 }}
                />
            </div>            
            </>
            }
            <Button variant="contained" size="medium" onClick={login} style={{ marginTop: '16px', marginBottom: '16px' }} >
                Login
            </Button>
        </div>
    )
}